import React from 'react'
import {
  IssueContainer,
  InnerIssueContainer,
  MainContent,
  IssueTitle,
  SidebarP,
  Sidebar,
  SidebarHeader,
  SidebarSubheader,
  CloseButton
} from '.'

interface Props {
  handleClose: () => void
}

export default function EnvironmentCard({ handleClose }: Props) {
  return (
    <IssueContainer>
      <InnerIssueContainer>
        <MainContent>
          <IssueTitle>Environmental Justice</IssueTitle>
          <SidebarP>
            The U.S. has a responsibility to address the existential threat of climate change and ensure a livable future for Americans and
            communities across the world. We have the solutions and must act in line with the consensus of the global scientific community.
            The Green New Deal provides a path forward guided by principles of environmental, economic, and racial justice.
          </SidebarP>
          <SidebarP>
            Minority and low-income communities in Nashville are disproportionately subjected to poorer air quality, higher asthma rates,
            and greater risk under extreme heat, cold, and flooding. Agriculture-based economies in Tennessee suffer from increasingly
            unpredictable weather conditions. Justin will stand up to corporations who poison our communities and profit from environmental
            destruction. He has pledged to reject campaign contributions from the coal, oil, and gas industry, which give millions to
            politicians to obstruct climate action. In office, Justin will advance the just and ethical path outlined by the Green New Deal
            to reach a 100% clean and renewable society, prioritizing workers and the most vulnerable communities.
          </SidebarP>
        </MainContent>
        <Sidebar>
          {/* <SidebarHeader>JUSTIN SUPPORTS</SidebarHeader>
          <SidebarSubheader href="https://www.congress.gov/bill/116th-congress/house-resolution/109">
            HR 109 - The Green New Deal resolution
          </SidebarSubheader>
          <SidebarP>Joining 96 co-sponsors, including Steve Cohen (TN-09).</SidebarP>
          <SidebarSubheader href="https://ocasio-cortez.house.gov/sites/ocasio-cortez.house.gov/files/OCASNY_053_xml.pdf">
            Green New Deal for Public Housing Act
          </SidebarSubheader>
          <SidebarP>
            Not yet introduced. This bill would create 240,000 jobs to modernize and improve 1.2 million units of public housing.
          </SidebarP> */}
          {/* <SidebarHeader>RESOURCES</SidebarHeader> */}
          <SidebarHeader>RESOURCES</SidebarHeader>
          <SidebarSubheader href="https://drrobertbullard.com/learn-about-environmental-justice/">
            Learn About Environmental Justice - Dr. Robert Bullard
          </SidebarSubheader>
          <SidebarSubheader href="https://www.ipcc.ch/sr15/chapter/spm/">Summary For Policymakers - IPCC Special Report</SidebarSubheader>
          <SidebarSubheader href="https://www.nytimes.com/interactive/2019/08/06/climate/world-water-stress.html">
            A Quarter of Humanity Faces Looming Water Crises
          </SidebarSubheader>
          <SidebarSubheader href="https://ocasio-cortez.house.gov/gnd/public-housing">
            Green New Deal For Public Housing Act
          </SidebarSubheader>
        </Sidebar>
      </InnerIssueContainer>
      <CloseButton onClick={handleClose}>CLOSE</CloseButton>
    </IssueContainer>
  )
}
